import { FC } from 'react';
import { Dialog, Grid, Typography, DialogContent } from '@mui/material';
import LazyImage from '../components/LazyImage';
import { useTranslations } from 'next-intl';

interface Props {
  opened: boolean;
  onClose: () => void;
}

export const ConnectCryptoMagnetInstruction: FC<Props> = ({ opened, onClose }) => {
  const t = useTranslations();

  return (
    <Dialog
      PaperProps={{
        sx: { zIndex: 1 }
      }}
      open={opened}
      onClose={onClose}
      scroll='body'
    >
      <DialogContent
        sx={{
          px: { xs: 4, sm: 4 },
          // py: { xs: 4, sm: 4 },
          pt: { xs: 4, sm: 4 },
          pb: { xs: '27px', sm: '27px' },
          position: 'relative',
          maxWidth: 450,
          background: '#1C1929'
        }}
      >
        <Grid style={{ marginTop: -10 }} container>
          <Grid display='flex' justifyContent='space-between' width='100%'>
            <Typography sx={{ color: 'white' }} style={{ color: 'white' }} color='white' variant='h5'>
              {t('common.additionalRegistration')}
            </Typography>
            <LazyImage
              style={{ position: 'relative', top: '-5px', cursor: 'pointer' }}
              onClick={onClose}
              src={'/images/icons/landing/close.svg'}
              alt='close'
            />
          </Grid>
          <Typography variant='body2' sx={{ color: 'white', mt: 1 }}>
            <div dangerouslySetInnerHTML={{ __html: t('common.cryptoMagnetInfo').replace(/\n/g, '<br />') }} />
          </Typography>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
